import { Entity } from "../../Entity";
import BankAccountFactory from "../../Factories/BankAccountFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { BankAccountInterface } from "./BankAccountInterface";

class BankAccount extends Entity implements BankAccountInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return BankAccountFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get contactId(): number {
    return this.data.contactId;
  }

  get companyId(): number {
    return this.data.companyId;
  }

  get agencyId(): number {
    return this.data.agencyId;
  }

  get accountId(): string {
    return this.data.accountId;
  }

  get isDefault(): boolean {
    return this.data.isDefault;
  }

  get name(): string {
    return this.data.name;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get label(): string {
    return this.data.label;
  }
}

export { BankAccount };
